import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import API_ROUTES from '../../api';
import axios from 'axios';
import {
    AutoCenter, Card, Grid, Button,
    Toast, Dialog, Selector, Divider, Badge
} from 'antd-mobile';
import Icon from '../../icon';
import GetSinglePersonFire from '../ApplicateOne/getSInglePersonFire';
import { getFormationLineCount as getModelCount, getMirroredFormationLineCount as getModelCount2 } from '../../features/match/model/formation';
import { getTeamAverage } from '../../features/match/model/teamStats';
import { getMatchMemberAvatar } from '../../features/match/model/memberAvatar';
import { useAuth } from '../../app/providers/AuthProvider';
import { LINEUP_VIEW_MODE, getLineupViewState, getMemberLineupTeam } from '../../features/match/model/captainWorkflow';
import { getPendingMemberTeamName, getReadyTeamName } from '../../features/match/model/readyTeamName';
import FormationPickerPopup from './formationPickerPopup';


const GameFirstInfo = ({ gameDetail, getGameDetail, getUserListInfo,
    memberListInfo, redCaptian, greenCaptain, tempLocalPos, setTempLocalPos }) => {

    const navigate = useNavigate()
    const { memberInfo } = useAuth()
    const [joinButtonLoading, setJoinButtonLoading] = useState(false)
    const [adminLineupTeam, setAdminLineupTeam] = useState(1)
    const [adminLineupMode, setAdminLineupMode] = useState(false)
    const [formationPopupVisible, setFormationPopupVisible] = useState(false)
    const [formationTypeInfo, setFormationTypeInfo] = useState(null)
    const [selectedFormation, setSelectedFormation] = useState(null)
    const [formationSubmitting, setFormationSubmitting] = useState(false)

    useEffect(() => {
        // 切换比赛时恢复队长本队视图，避免沿用上一场的管理员代排选择。
        setAdminLineupTeam(1)
        setAdminLineupMode(false)
    }, [gameDetail?.id])
    
    // Team naming logic synchronized with GameTitleTeam
    const getTeamName = (teamIndex) => {
        return getReadyTeamName(gameDetail, teamIndex);
    }

    const refereeListInfo = memberListInfo?.length > 0 ?
        memberListInfo?.filter(item => item.gameType === 1 || item.gameType === 2) : []
    const canManageMatch = memberInfo?.admin === 1
        || refereeListInfo.some(referee => referee.id === memberInfo?.id)

    const ROLE_COLORS = {
        1: { color: '#EE7700', bg: '#FFDDAA', text: '门将' },
        2: { color: '#888800', bg: '#FFFFBB', text: '边后卫' },
        3: { color: '#00DD00', bg: '#99FF99', text: '中后卫' },
        4: { color: '#00DDDD', bg: '#99FFFF', text: '后腰' },
        5: { color: '#0000CC', bg: '#CCCCFF', text: '边前卫' },
        6: { color: '#CC00CC', bg: '#FFB3FF', text: '前腰' },
        7: { color: '#CC0000', bg: '#FFCCCC', text: '前锋' },
        12: { color: '#CC0000', bg: '#FFCCCC', text: '待选队伍' },
    };

    const POSITION_OPTIONS = [
        { label: '门将', value: 1 },
        { label: '边后卫', value: 2 },
        { label: '中后卫', value: 3 },
        { label: '后腰', value: 4 },
        { label: '边前卫', value: 5 },
        { label: '前腰', value: 6 },
        { label: '前锋', value: 7 },
    ];

    const [displayList, setDisplayList] = useState([]);

    const getFireDetailInfo = useCallback(() => {
        const showMembers = memberListInfo
            ?.filter((item) => null !== item.gameType && item.gameType <= 7)
            ?.map((item) => item.id)
            ?.join(',');

        if (!showMembers) {
            setDisplayList([]);
            return;
        }

        Toast.show({ icon: 'loading', content: '加载中...' });
        axios
            .get(API_ROUTES.game_member_fail_info, {
                params: { memberId: showMembers }
            })
            .then((res) => {
                const data = res.data.data || {};
                setDisplayList(data);
            })
            .catch(() => {
                Toast.show({ icon: 'fail', content: '查询失败' });
                setDisplayList([]);
            })
            .finally(() => Toast.clear());
    }, [memberListInfo]);

    useEffect(() => {
        if (memberListInfo && memberListInfo.length > 0) {
            getFireDetailInfo();
        }
    }, [getFireDetailInfo, memberListInfo]);


    const badgeContent = (user) => {
        let result = [];
        if (user.redCardFlag === 1) {
            result.push(
                <img key="goal" src={Icon.RED_CARD}
                    alt="red card"
                    style={{ width: '12px', height: '12px' }}
                />
            );
        }
        if (user.yellowCardFlag === 1) {
            result.push(
                <img key="goal" src={Icon.YELLOW_CARD}
                    alt="yellow card"
                    style={{ width: '12px', height: '12px' }}
                />
            );
        }
        if (user.upDown === 1) {
            result.push(
                <img key="goal" src={Icon.UP_ICON}
                    alt="up icon"
                    style={{ width: '12px', height: '12px' }}
                />
            );
        } else if (user.upDown === 0) {
            result.push(
                <img key="goal" src={Icon.DOWN_ICON}
                    alt="down icon"
                    style={{ width: '12px', height: '12px' }}
                />
            );
        }
        return result;
    };

    const getMemberImage = (user) => getMatchMemberAvatar(user, gameDetail, Icon)

    // 阵型与对阵人数统一在底部面板完成，避免连续打开两个居中对话框。
    const openFormationPicker = () => {
        const typeInfo = Number(gameDetail?.typeInfo) || null
        if (!typeInfo && memberInfo?.admin !== 1) {
            Toast.show({ content: '请管理员先设置场上人数，再继续排阵', icon: 'fail' })
            return
        }
        setFormationTypeInfo(typeInfo)
        setSelectedFormation(null)
        setFormationPopupVisible(true)
    }

    const selectMatchSize = async (typeInfo) => {
        setFormationSubmitting(true)
        try {
            const response = await axios.post(API_ROUTES.game_updateGameInfo, {
                gameId: gameDetail.id,
                memberId: memberInfo?.id,
                type: String(typeInfo),
            }, {})
            if (response.data.code !== 200) {
                Toast.show({ content: response.data.msg || '设置对阵人数失败', icon: 'fail' })
                return
            }
            setFormationTypeInfo(typeInfo)
            setSelectedFormation(null)
            getGameDetail()
        } catch (error) {
            Toast.show({ content: '设置对阵人数失败，请重试', icon: 'fail' })
        } finally {
            setFormationSubmitting(false)
        }
    }

    const submitFormation = async () => {
        if (!selectedFormation) {
            Toast.show({ content: '请先选择阵型', icon: 'fail' })
            return
        }
        if (!lineupOperatorId) {
            Toast.show({ content: '未找到当前队伍队长，请刷新后重试', icon: 'fail' })
            return
        }
        setFormationSubmitting(true)
        try {
            const formData = new FormData()
            formData.append('memberId', lineupOperatorId)
            formData.append('type', selectedFormation)
            formData.append('gameId', gameDetail.id)
            const response = await axios.post(API_ROUTES.game_teamModel, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            if (response.data.code !== 200) {
                Toast.show({ content: response.data.msg || '保存阵型失败', icon: 'fail' })
                return
            }
            setFormationPopupVisible(false)
            Toast.show({ content: `${activeTeamName}阵型已确认，请安排首发球员`, icon: 'success' })
            getGameDetail()
        } catch (error) {
            Toast.show({ content: '保存阵型失败，请重试', icon: 'fail' })
        } finally {
            setFormationSubmitting(false)
        }
    }
    const avgAge = (team) => getTeamAverage(memberListInfo, team, 'age')

    const avgGrade = (team) => getTeamAverage(memberListInfo, team, 'integral')

    const getModelContent = (type) => {
        switch (type) {
            case 1:
                return '1-3-2-2'
            case 2:
                return '1-3-3-1'
            case 3:
                return '1-4-4-2'
            case 4:
                return '1-5-3-2'
            case 5:
                return '1-3-5-2'
            case 6:
                return '1-5-4-1'
            case 7:
                return '1-4-5-1'
            case 8:
                return '1-4-4-3'
            case 9:
                return '1-5-4-2'
            case 10:
                return '1-4-5-2'
            case 11:
                return '1-5-5-1'
            case 12:
                return '1-5-3-3'
            case 13:
                return '1-3-3-2'
            case 14:
                return '1-3-4-1'
            case 15:
                return '1-4-3-1'
            default:
                return ''
        }
    }

    const getUserSubstituteInfo = (team, filterType) => {
        // 确保必要数据存在
        if (!gameDetail || !Array.isArray(memberListInfo)) {
            return null;
        }

        // 定义不同过滤类型的处理函数
        const filterHandlers = {
            // 第一种过滤类型：过滤firstRelease !== 1的成员
            type1: (item) => item.gameTeam === team && item.firstRelease !== 1,

            // 第二种过滤类型：过滤不在tempLocalPos中的成员
            type2: (item) => {
                const matchingItem = tempLocalPos?.find(others => others.id === item.id);
                return !matchingItem && item.gameTeam === team;
            },

            // 第三种过滤类型：过滤不在userPositionJson中的成员
            type3: (item) => {
                const userPosition = team === 1 ? gameDetail?.greenModelConfirm : gameDetail?.redModelConfirm;
                const userPositionJson = userPosition ? JSON.parse(userPosition) : null;

                if (userPositionJson === null) {
                    return item.gameTeam === team;
                } else {
                    const matchingItem = userPositionJson?.find(others => others.id === item.id);
                    return !matchingItem && item.gameTeam === team;
                }
            }
        };

        // 根据过滤类型获取当前用户列表
        const filterHandler = filterHandlers[filterType] || filterHandlers.type1;
        const currentUsers = memberListInfo?.filter(filterHandler)
            .sort((a, b) => {
                const isCaptainA = a.id === redCaptian?.id || a.id === greenCaptain?.id;
                const isCaptainB = b.id === redCaptian?.id || b.id === greenCaptain?.id;

                if (isCaptainA && !isCaptainB) return -1;
                if (!isCaptainA && isCaptainB) return 1;

                const isSubCaptainA = a.subCaptain;
                const isSubCaptainB = b.subCaptain;

                if (isCaptainA && isSubCaptainB) return -1;
                if (isSubCaptainA && isCaptainB) return 1;

                if (isSubCaptainA && !isSubCaptainB) return -1;
                if (!isSubCaptainA && isSubCaptainB) return 1;

                return a.gameRole - b.gameRole;
            });

        // 渲染列表项的函数，可根据需要进一步参数化
        const renderListItem = (user) => {

            let isCaptain = [gameDetail?.redCaptainId, gameDetail?.greenCaptainId].includes(user.id);

            // 只有管理员或对应队伍队长可以授予副队长，避免跨队操作。
            const isCurrentTeamCaptain = (user.gameTeam === 1 && gameDetail.greenCaptainId === memberInfo?.id)
                || (user.gameTeam === 2 && gameDetail.redCaptainId === memberInfo?.id);
            const hasPermission = canManageMatch || isCurrentTeamCaptain;

            let teamHasSubCaptain = (user.gameTeam === 1 && memberListInfo?.some(item => item.gameTeam === 1 && item.subCaptain === 1)) ||
                (user.gameTeam === 2 && memberListInfo?.some(item => item.gameTeam === 2 && item.subCaptain === 1));

            let showSubCaptainButton = hasPermission && !isCaptain && user.tempMember === null && !teamHasSubCaptain;

            const teamColor = user.gameTeam === 1 ? gameDetail?.greenColor : gameDetail?.redColor;

            return (
                <div
                    className={`sub-player-card unified-sub-player-card team-${user.gameTeam}`}
                    key={user.id}
                    style={{
                        '--sub-team-color': teamColor || '#6d98f5'
                    }}
                >
                    {/* 左侧头像区 */}
                    <div className="sub-avatar-container" onClick={() => navigate(`/members/${user.id}`)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative' }}>
                        <Badge
                            color='orange'
                            content={user.goalFlag === 1 ?
                                <img key="goal" src={Icon.GOAL} alt="goal" style={{ width: '14px', height: '14px' }} /> : null
                            }
                            style={{ '--left': '100%', '--top': '100%', backgroundColor: 'transparent' }}
                        >
                            <Badge
                                content={badgeContent(user)}
                                style={{ zIndex: '1', backgroundColor: 'transparent' }}
                                bordered={false}
                            >
                                <div className="sub-avatar-wrapper" style={{
                                    border: (gameDetail?.greenCaptainConfirm >= 1 && gameDetail?.redCaptainConfirm >= 1) ? 
                                            (user.gameTeam === 1 ? '2px solid ' + gameDetail.greenColor : '2px solid ' + gameDetail.redColor) : 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    width: '44px',
                                    height: '44px',
                                    borderRadius: '50%'
                                }}>
                                    <img
                                        src={getMemberImage(user)}
                                        className="sub-avatar-img"
                                        alt={user.name}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </div>
                            </Badge>
                        </Badge>

                        {/* 队长/副队长标识 */}
                        {(user.id === redCaptian?.id || user.id === greenCaptain?.id) ? (
                            <img src={Icon.CAPTAIN} className="sub-captain-icon" style={{ position: 'absolute', top: '-5px', right: '-5px', width: '16px', height: '16px', zIndex: 10 }} alt="cap" />
                        ) : user.subCaptain === 1 ? (
                            <img src={Icon.SUB_CAPTAIN} className="sub-captain-icon" style={{ position: 'absolute', top: '-5px', right: '-5px', width: '18px', height: '18px', zIndex: 10 }} alt="sub" />
                        ) : null}
                    </div>

                    {/* 中间信息区 */}
                    <div className="sub-info-container" onClick={() => navigate(`/members/${user.id}`)}>
                        <div className="sub-name-text">{user.name}</div>
                        <div className="sub-role-text">{user.gameRoleName || '球员'}</div>
                    </div>

                    {/* 副队长操作固定在右上角，不占用姓名和位置区域。 */}
                    {showSubCaptainButton && (
                        <div className="sub-action-container">
                            <Button
                                className="premium-vice-btn"
                                title="设为副队长"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    Dialog.confirm({
                                        title: (
                                            <div className="premium-dialog-header">
                                                <span className="premium-dialog-title-icon">🎖️</span>
                                                <span className="premium-dialog-title-text">设置副队长</span>
                                            </div>
                                        ),
                                        content: (
                                            <div className="premium-dialog-container">
                                                <div className="premium-confirm-details">
                                                    <div className="premium-confirm-item">
                                                        <span className="premium-confirm-label">球员</span>
                                                        <span className="premium-confirm-value">{user?.name}</span>
                                                    </div>
                                                </div>
                                                <div className="premium-tip-banner">
                                                    <span className="premium-tip-icon">💡</span>
                                                    <span className="premium-tip-text">确认将其设为当前队伍的副队长吗？</span>
                                                </div>
                                            </div>
                                        ),
                                        onConfirm: () => {
                                            Toast.show({ icon: 'loading', duration: 0 });
                                            const formData = new FormData();
                                            formData.append('memberId', user?.id);
                                            formData.append('gameId', gameDetail.id);
                                            axios.post(API_ROUTES.game_setSubCaptain, formData, {
                                                headers: { 'Content-Type': 'multipart/form-data' }
                                            }).then((res) => {
                                                if (res.data.code === 200) {
                                                    Toast.show({
                                                        icon: 'success',
                                                        content: "设置成功！",
                                                        afterClose: () => {
                                                            getGameDetail();
                                                            getUserListInfo();
                                                        }
                                                    });
                                                } else {
                                                    Toast.show({ icon: 'fail', content: res.data.msg || "系统错误" });
                                                }
                                            }).catch(() => {
                                                Toast.show({ icon: 'fail', content: "网络错误" });
                                            });
                                        },
                                    });
                                }}
                            >
                                副+
                            </Button>
                        </div>
                    )}
                </div>
            );
        };

        // 返回渲染结果
        return currentUsers?.map(renderListItem);
    };

    // ── Member Selector Component for Lineup Picker ──
    const MemberSelector = ({ members, onSelect, selectedId }) => {
        const [activeId, setActiveId] = useState(selectedId);

        return (
            <div className="premium-selection-grid">
                {members.length > 0 ? (
                    members.map(player => (
                        <div
                            key={player.id}
                            className={`selection-player-card ${activeId === player.id ? 'selection-player-card-active' : ''}`}
                            onClick={() => {
                                setActiveId(player.id);
                                onSelect(player.id);
                            }}
                        >
                            <img
                                src={getMemberImage(player)}
                                alt={player.name}
                                className="selection-player-avatar"
                            />
                            <div className="selection-player-name">{player.name}</div>
                        </div>
                    ))
                ) : (
                    <div style={{
                        gridColumn: 'span 3',
                        padding: '40px 0',
                        textAlign: 'center',
                        color: '#86909C',
                        fontSize: '14px'
                    }}>
                        ⚽ 所有队员均已安排位置
                    </div>
                )}
            </div>
        );
    };

    const getUserPositionInfo = (team, isConfirm = false) => {
        const userComponentsFuc = (line, team, count) => {
            const userComponents = [];
            const positionData = isConfirm
                ? (team === 1 ? gameDetail?.greenModelConfirm : gameDetail?.redModelConfirm)
                : tempLocalPos;
            const parsedPositionData = positionData ? (isConfirm ? JSON.parse(positionData) : positionData) : null;

            for (let i = 0; i < count; i++) {
                const tempMember = parsedPositionData?.filter(item =>
                    item.line === line && item.team === team && item.pos === i
                );
                if (tempMember?.length > 0) {
                    const tempCurrentMember = memberListInfo?.filter(
                        item => item.id === tempMember[0].id
                    );

                    const badgeContent = tempCurrentMember[0]?.id === redCaptian?.id || tempCurrentMember[0]?.id === greenCaptain?.id ?
                        <img
                            key={tempCurrentMember[0]?.id + "captain"}
                            src={Icon.CAPTAIN}
                            alt="captain"
                            style={{ width: '16px', height: '16px', backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: '50%', border: '1px solid rgba(22, 93, 255, 0.15)' }}
                        /> :
                        tempCurrentMember[0].subCaptain === 1 ?
                            <img
                                key={tempCurrentMember[0]?.id + "subCaptain"}
                                src={Icon.SUB_CAPTAIN}
                                alt="sub captain"
                                style={{ width: '18px', height: '18px', backgroundColor: 'white', borderRadius: '50%' }}
                            /> : null;

                    const gridItem = (
                        <Grid.Item
                            onClick={isConfirm
                                ? () => navigate(`/members/${tempCurrentMember[0].id}`)
                                : () => {
                                    Dialog.confirm({
                                        content: '确定将' + tempCurrentMember[0].name + '放到替补吗?',
                                        onConfirm: () => {
                                            const filteredMembers = tempLocalPos?.filter(member => member.id !== tempCurrentMember[0].id);
                                            localStorage.setItem("memberTempPos", JSON.stringify(filteredMembers));
                                            setTempLocalPos(filteredMembers);
                                        }
                                    });
                                }
                            }
                        >
                            <AutoCenter>
                                <Badge color='none' content={badgeContent} style={{ '--right': '100%', '--top': '100%' }}>
                                    <img
                                        src={getMemberImage(tempCurrentMember[0])}
                                        alt={tempCurrentMember[0]?.name || ''}
                                        width={40}
                                        height={40}
                                        fit='cover'
                                        style={{
                                            borderRadius: 50,
                                            border: (gameDetail?.greenCaptainConfirm >= 1 && gameDetail?.redCaptainConfirm >= 1) ?
                                                    (team === 1 ? `2px solid ${gameDetail.greenColor}` : `2px solid ${gameDetail.redColor}`) : 'none',
                                            backgroundColor: "white"
                                        }}
                                    />
                                </Badge>
                            </AutoCenter>
                            <AutoCenter className="pitch-player-name-glow" style={{ fontSize: 13, marginTop: 2 }}>
                                {tempCurrentMember[0]?.name}
                            </AutoCenter>
                            <div style={{
                                height: 16,
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                marginTop: -2,
                                filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.5))'
                            }}>
                                <GetSinglePersonFire
                                    records={displayList[tempCurrentMember[0]?.id]}
                                    count={3}
                                    trendType="unbeaten"
                                />
                                <GetSinglePersonFire
                                    records={displayList[tempCurrentMember[0]?.id]}
                                    count={3}
                                    trendType="winless"
                                />
                            </div>
                        </Grid.Item>
                    );

                    userComponents.push(gridItem);
                } else if (!isConfirm) {
                    userComponents.push(
                        <Grid.Item
                            onClick={() => {
                                let confirmMember;
                                const currentTeam = memberListInfo?.filter(item => {
                                    const matchingItem = tempLocalPos?.find(others => others.id === item.id);
                                    return !matchingItem && item.gameTeam === team;
                                });

                                Dialog.confirm({
                                    title: (
                                        <div className="premium-dialog-header">
                                            <span className="premium-dialog-title-icon">⚽</span>
                                            <span className="premium-dialog-title-text">选择当前位置首发人员</span>
                                        </div>
                                    ),
                                    content: (
                                        <MemberSelector
                                            members={currentTeam}
                                            selectedId={confirmMember}
                                            onSelect={(id) => confirmMember = id}
                                        />
                                    ),
                                    onConfirm: () => {
                                        if (confirmMember) {
                                            setTempLocalPos([...tempLocalPos, { 'line': line, 'team': team, 'pos': i, 'id': confirmMember }]);
                                            localStorage.setItem("memberTempPos", JSON.stringify([...tempLocalPos, { 'line': line, 'team': team, 'pos': i, 'id': confirmMember }]));
                                        } else {
                                            Toast.show({
                                                icon: 'fail',
                                                content: '请选择一位队员'
                                            });
                                        }
                                    }
                                });
                            }}
                        >
                            <AutoCenter>
                                <img
                                    src={Icon.KEPENG_LOGO}
                                    alt="空阵容位置"
                                    width={40}
                                    height={40}
                                    fit='cover'
                                    style={{
                                        borderRadius: 50,
                                        backgroundColor: "white",
                                        border: (gameDetail?.greenCaptainConfirm >= 1 && gameDetail?.redCaptainConfirm >= 1) ?
                                                (team === 1 ? `2px solid ${gameDetail.greenColor}` : `2px solid ${gameDetail.redColor}`) : 'none',
                                    }}
                                />
                            </AutoCenter>
                        </Grid.Item>
                    );
                }
            }

            return userComponents;
        }

        const grids = [];
        for (let i = 1; i <= 4; i++) {
            const tempCount = team === 1
                ? getModelCount(gameDetail?.greenModel, i)
                : getModelCount2(gameDetail?.redModel, i);

            grids.push(
                <Grid key={`grid-${i}`} columns={tempCount ? tempCount : 1} style={{ width: '100%', height: '80px' }}>
                    {userComponentsFuc(i, team, tempCount)}
                </Grid>
            );
        }

        return grids;
    }



    const getPendingMembers = () => memberListInfo?.filter(item => item.gameType === 0 && item.gameTeam === null) || [];

    const renderPendingTitle = () => {
        const pendingCount = getPendingMembers().length;
        if (pendingCount <= 0) return null;
        return (
            <div className="waiting-team-title">
                <span className="waiting-team-title-mark"></span>
                <span>待选队队员</span>
                <em>{pendingCount}人</em>
            </div>
        );
    };

    const canOperatePendingMember = (user) => {
        if (!user || user.gameTeam !== null) return false;
        if (memberInfo?.admin === 1) return true;
        if (memberInfo?.id === user.id) return true;
        // 根据阵容确认字段判断队长权限：本人和管理员全程可操作，队长在自己阵容确认前可处理待选队员。
        if (memberInfo?.id === greenCaptain?.id && gameDetail?.greenModelConfirm == null) return true;
        if (memberInfo?.id === redCaptian?.id && gameDetail?.redModelConfirm == null) return true;
        return false;
    };

    const getUserRoleInfo = (type, team, flag) => {
        if (!(gameDetail && Array.isArray(memberListInfo))) return null;

        // 过滤成员数据（保持原有逻辑）
        let currentUser = memberListInfo?.filter(user =>
            user.gameRole === type
            && user.gameTeam === team
            && user.id !== redCaptian?.id
            && user.id !== greenCaptain?.id
        );

        if (flag > 0) {
            currentUser = memberListInfo?.filter(item => item.gameType === 0 && item.gameTeam === null);
        }

        // 不败火焰（头部悬浮）
        const renderFireHeader = (user) => (
            <div className="card-fire-header">
                <GetSinglePersonFire
                    records={displayList[user.id]}
                    count={3}
                    trendType="unbeaten"
                />
            </div>
        );

        // 不胜火焰（底部悬浮）
        const renderFireFooter = (user) => (
            <div className="card-fire-footer">
                <GetSinglePersonFire
                    records={displayList[user.id]}
                    count={3}
                    trendType="winless"
                />
            </div>
        );

        // 采用高级玻璃感卡片样式 (同步 gameReadyStepOne.jsx)
        return currentUser.map((user) => (
            <Grid.Item key={user.id}>
                <div
                    className="mini-player-item"
                    style={{
                        position: 'relative',
                        overflow: 'visible',
                        cursor: 'pointer'
                    }}
                    onClick={() => {
                        const changeMemberPosition = () => {
                            let selectTeam = []
                            let selectPosition = user.gameRole && user.gameRole !== 12 ? [user.gameRole] : []
                            Dialog.confirm({
                                className: 'waiting-team-dialog',
                                title: (
                                    <div className="waiting-team-dialog-title">
                                        <span>加入阵容</span>
                                        <em>选择队伍与位置</em>
                                    </div>
                                ),
                                content: (
                                    <div className="waiting-team-dialog-body">
                                        <div className="waiting-team-player">
                                            <img src={getMemberImage(user)} alt={user.name} />
                                            <div>
                                                <strong>{user.name}</strong>
                                                <span>选择队伍和场上位置</span>
                                            </div>
                                        </div>
                                        <div className="waiting-team-section-title">选择所属阵容</div>
                                        {/* 首发阶段沿用同一队名规则，避免弹窗退回 A/B 代号。 */}
                                        <Selector
                                            className="waiting-team-selector waiting-team-selector--team"
                                            options={[
                                                { label: getPendingMemberTeamName(gameDetail, 1), value: 1 },
                                                { label: getPendingMemberTeamName(gameDetail, 2), value: 2 },
                                            ]}
                                            columns={2}
                                            onChange={a => (selectTeam = a)}
                                        />
                                        <div className="waiting-team-section-title">选择场上位置</div>
                                        <Selector
                                            className="waiting-team-selector waiting-team-selector--role"
                                            options={POSITION_OPTIONS}
                                            columns={3}
                                            defaultValue={selectPosition}
                                            onChange={a => (selectPosition = a)}
                                        />
                                    </div>
                                ),
                                onConfirm: () => {
                                    if (!selectTeam?.length) {
                                        Toast.show({ icon: 'fail', content: '请选择队伍' })
                                        return Promise.reject();
                                    }
                                    if (!selectPosition?.length) {
                                        Toast.show({ icon: 'fail', content: '请选择位置' })
                                        return Promise.reject();
                                    }
                                    const data = {
                                        team: selectTeam[0],
                                        position: selectPosition[0],
                                        gameId: gameDetail.id,
                                        userId: user.id
                                    };
                                    axios.post(API_ROUTES.game_changePosition, data, {})
                                        .then(() => {
                                            Toast.show({
                                                icon: 'success',
                                                content: '修改成功',
                                                duration: 2
                                            })
                                            getUserListInfo()
                                        })
                                        .catch(() => {
                                            Toast.show({
                                                icon: 'fail',
                                                content: '修改失败',
                                            })
                                        })
                                        .finally(() => {
                                            Toast.clear()
                                        });
                                }
                            })
                        }
                        if (canOperatePendingMember(user)) {
                            changeMemberPosition()
                        }
                    }}
                >
                    <div className="mini-avatar-wrapper">
                        <img
                            src={getMemberImage(user)}
                            className="mini-avatar"
                            alt={user.name}
                            style={{
                                border: (gameDetail?.greenCaptainConfirm >= 1 && gameDetail?.redCaptainConfirm >= 1) ? 
                                        (user.gameTeam === 1 ? `2px solid ${gameDetail.greenColor}` : `2px solid ${gameDetail.redColor}`) : 'none',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)'
                            }}
                        />
                    </div>

                    <div style={{
                        marginTop: '4px',
                        padding: '1px 6px',
                        borderRadius: 4,
                        fontSize: '10px',
                        background: `${ROLE_COLORS[user.gameRole]?.bg || 'rgba(255,255,255,0.1)'}`,
                        color: ROLE_COLORS[user.gameRole]?.color || '#fff',
                        fontWeight: 700,
                        whiteSpace: 'nowrap'
                    }}>
                        {ROLE_COLORS[user.gameRole]?.text || '未设置'}
                    </div>

                    <div className="mini-player-name" style={{ marginTop: '2px' }}>
                        {user.name}
                    </div>

                    {renderFireHeader(user)}
                    {renderFireFooter(user)}
                </div>
            </Grid.Item>
        ));
    };


    const isAdmin = memberInfo?.admin === 1
    const ownLineupTeam = getMemberLineupTeam({ gameDetail, memberInfo, memberList: memberListInfo })
    // 兼任管理员的队长默认只操作本队；需要代排时主动切换管理员模式。
    const canAdminChooseTeam = isAdmin && Number(gameDetail?.gameType) === 3
        && (!ownLineupTeam || adminLineupMode)
    const lineupViewState = getLineupViewState({
        gameDetail, memberInfo, memberList: memberListInfo,
        adminTeam: adminLineupTeam, adminOverride: adminLineupMode
    })
    // 队长或本队副队长使用本人 ID 排阵；管理员代排时提交当前队伍的队长 ID。
    const lineupOperatorId = canAdminChooseTeam
        ? (adminLineupTeam === 1 ? gameDetail?.greenCaptainId : gameDetail?.redCaptainId)
        : memberInfo?.id
    const activeLineupTeam = lineupViewState.editableTeam
    const otherLineupTeam = activeLineupTeam === 1 ? 2 : 1
    const activeTeamName = activeLineupTeam ? getTeamName(activeLineupTeam) : ''
    const otherTeamName = getTeamName(otherLineupTeam)
    // 队伍颜色与顶部队伍信息保持一致；浅色球衣使用深色文字保证按钮可读。
    const rawTeamColor = activeLineupTeam === 1 ? gameDetail?.greenColor : gameDetail?.redColor
    const activeTeamColor = rawTeamColor === 'green' ? '#10b981'
        : rawTeamColor === 'red' ? '#ef4444'
            : /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(rawTeamColor || '')
                ? rawTeamColor : '#346cde'
    const colorHex = activeTeamColor.length === 4
        ? activeTeamColor.slice(1).split('').map(value => value + value).join('')
        : activeTeamColor.slice(1)
    const colorChannels = [0, 2, 4].map(index => parseInt(colorHex.slice(index, index + 2), 16))
    const activeTeamTextColor = (colorChannels[0] * 299 + colorChannels[1] * 587 + colorChannels[2] * 114) / 1000 > 160
        ? '#223047' : '#fff'
    const lineupStageText = lineupViewState.mode === LINEUP_VIEW_MODE.CHOOSE_FORMATION
        ? '待选择阵型'
        : lineupViewState.mode === LINEUP_VIEW_MODE.EDIT_LINEUP
            ? '待安排首发球员'
            : '首发阵容已确认'
    // 队伍切换只保留一个次级入口；切换时清理草稿，防止把另一队的球员带入当前阵容。
    const switchLineupTeam = () => {
        setTempLocalPos([])
        localStorage.removeItem('memberTempPos')
        setFormationPopupVisible(false)
        if (ownLineupTeam) {
            setAdminLineupTeam(otherLineupTeam)
            setAdminLineupMode(current => !current)
        } else {
            setAdminLineupTeam(otherLineupTeam)
        }
    }
    const canSwitchLineupTeam = isAdmin && Number(gameDetail?.gameType) === 3 && activeLineupTeam
    const lineupSwitchButton = canSwitchLineupTeam && <button
        type="button"
        className="lineup-switch-team"
        onClick={switchLineupTeam}
        aria-label={`切换到${otherTeamName}排阵`}
    ><span aria-hidden="true">⇄</span> 切换至{otherTeamName}</button>
    // 当前队伍缩为一行；选择阵型阶段将切换与选阵型并排，操作归属始终可见。
    const lineupTeamSelector = (
        <section className="lineup-workspace-header">
            <div className="lineup-workspace-heading">
                <strong>首发排阵</strong>
                <span>{lineupStageText}</span>
            </div>
            <div className="lineup-context-row">
                {activeLineupTeam && <div className="lineup-current-team" style={{ '--lineup-team-color': activeTeamColor }}>
                    <span>当前{activeLineupTeam === 1 ? '主队' : '客队'}</span>
                    <strong>{activeTeamName}</strong>
                </div>}
                {lineupViewState.mode !== LINEUP_VIEW_MODE.CHOOSE_FORMATION && lineupSwitchButton}
            </div>
        </section>
    )
    const lineupFormationActions = <div className="lineup-formation-actions">
        {lineupSwitchButton}
        <Button
            block
            className="premium-btn-formation lineup-formation-primary"
            style={{ '--lineup-team-color': activeTeamColor, '--lineup-team-text': activeTeamTextColor }}
            color='none'
            onClick={openFormationPicker}
        ><span className="premium-btn-formation-icon">⚽</span> 为{activeTeamName}选阵型</Button>
    </div>

    if (lineupViewState.mode === LINEUP_VIEW_MODE.CHOOSE_FORMATION && lineupViewState.editableTeam === 2) {
        return (
            <div>
                {lineupTeamSelector}
                <FormationPickerPopup
                    visible={formationPopupVisible}
                    teamName={getTeamName(2)}
                    typeInfo={formationTypeInfo}
                    selected={selectedFormation}
                    submitting={formationSubmitting}
                    onClose={() => setFormationPopupVisible(false)}
                    onSelect={setSelectedFormation}
                    onSelectSize={selectMatchSize}
                    onConfirm={submitFormation}
                />
                {lineupFormationActions}
                <div className="lineup-section-label">首发位置</div>

                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    color: '#1D2129'
                }}>
                    <div className="premium-pitch-container" style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '800px',
                        // 足球场背景统一从 icon.js 获取，方便后续整体替换
                        backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>
                        <div className="pitch-premium-divider"></div>

                        {/* Team A - Upper Half */}
                        <div className="team-pitch-area">
                            <div className="pitch-info-bar pitch-info-bar-top">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                </div>
                            </div>
                            {getUserPositionInfo(1, true)}
                        </div>

                        {/* Team B - Lower Half */}
                        <div className="team-pitch-area">
                            {getUserPositionInfo(2, true)}
                            <div className="pitch-info-bar pitch-info-bar-bottom">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Divider>替补阵容</Divider>
                <Grid columns={10} gap={8}>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(1)}队长: {greenCaptain?.name}
                        </div>
                        {getUserSubstituteInfo(1, 'type1')}
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(2)}队长: {redCaptian?.name}
                        </div>
                        {getUserSubstituteInfo(2, 'type1')}
                    </Grid.Item>
                </Grid>
                {renderPendingTitle()}
                <Grid columns={3} gap={8} >
                    {getUserRoleInfo(null, 3, 1)}
                </Grid>
            </div>
        )
    } else if (lineupViewState.mode === LINEUP_VIEW_MODE.CHOOSE_FORMATION && lineupViewState.editableTeam === 1) {
        return (
            <div>
                {lineupTeamSelector}
                <FormationPickerPopup
                    visible={formationPopupVisible}
                    teamName={getTeamName(1)}
                    typeInfo={formationTypeInfo}
                    selected={selectedFormation}
                    submitting={formationSubmitting}
                    onClose={() => setFormationPopupVisible(false)}
                    onSelect={setSelectedFormation}
                    onSelectSize={selectMatchSize}
                    onConfirm={submitFormation}
                />
                {lineupFormationActions}
                <div className="lineup-section-label">首发位置</div>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    color: '#1D2129'
                }}>
                    <div className="premium-pitch-container" style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '800px',
                        // 足球场背景统一从 icon.js 获取，方便后续整体替换
                        backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>
                        <div className="pitch-premium-divider"></div>

                        <div className="team-pitch-area">
                            <div className="pitch-info-bar pitch-info-bar-top">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                </div>
                            </div>
                            {getUserPositionInfo(1, true)}
                        </div>

                        <div className="team-pitch-area">
                            {getUserPositionInfo(2, true)}
                            <div className="pitch-info-bar pitch-info-bar-bottom">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Divider>替补阵容</Divider>
                <Grid columns={10} gap={8}>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(1)}队长: {greenCaptain?.name}
                        </div>
                        {getUserSubstituteInfo(1, 'type1')}
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(2)}队长: {redCaptian?.name}
                        </div>
                        {getUserSubstituteInfo(2, 'type1')}
                    </Grid.Item>
                </Grid>
                {renderPendingTitle()}
                <Grid columns={3} gap={8} >
                    {getUserRoleInfo(null, 3, 1)}
                </Grid>
            </div>
        )
    } else if (lineupViewState.mode === LINEUP_VIEW_MODE.EDIT_LINEUP && lineupViewState.editableTeam === 2) {
        return (
            <div>
                {lineupTeamSelector}
                <div className="lineup-section-label">首发位置</div>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    color: '#1D2129'
                }}>
                    <div className="premium-pitch-container" style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '800px',
                        // 足球场背景统一从 icon.js 获取，方便后续整体替换
                        backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>
                        <div className="pitch-premium-divider"></div>

                        {/* Team A - Top */}
                        <div className="team-pitch-area">
                            <div className="pitch-info-bar pitch-info-bar-top">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                </div>
                            </div>
                            {getUserPositionInfo(1, true)}
                        </div>

                        {/* Team B - Bottom */}
                        <div className="team-pitch-area">
                            {getUserPositionInfo(2, false)}
                            <div className="pitch-info-bar pitch-info-bar-bottom">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="premium-btn-formation-wrapper">
                    <Button
                        className="premium-btn-formation"
                        block
                        color='none'
                        loading={joinButtonLoading}
                        onClick={() => {
                            setJoinButtonLoading(true)
                            const formData = new FormData();
                            formData.append('memberId', lineupOperatorId);
                            formData.append('pos', JSON.stringify(tempLocalPos));
                            formData.append('gameId', gameDetail.id)
                            axios.post(API_ROUTES.game_firstModel, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                                .then(function (response) {
                                    const result = response.data
                                    if (result.code === 200) {
                                        Toast.show({
                                            icon: 'success',
                                            content: "确认成功！"
                                        })
                                        getGameDetail()
                                        localStorage.removeItem("memberTempPos")
                                    } else {
                                        console.log(result)
                                        Toast.show({
                                            icon: 'fail',
                                            content: result.msg
                                        })
                                    }
                                })
                                .catch(function (error) {
                                    Toast.show({
                                        icon: 'fail',
                                        content: "系统错误！请联系管理员",
                                    })
                                })
                                .finally(() => {
                                    setJoinButtonLoading(false)
                                });
                        }}>
                        <span className="premium-btn-formation-icon">✓</span> 确认首发阵容
                    </Button>
                </div>
                <Divider>替补阵容</Divider>
                <Grid columns={10} gap={8}>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(1)}队长: {greenCaptain?.name}
                        </div>
                        {getUserSubstituteInfo(1, 'type3')}
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(2)}队长: {redCaptian?.name}
                        </div>
                        {getUserSubstituteInfo(2, 'type3')}
                    </Grid.Item>
                </Grid>
                {renderPendingTitle()}
                <Grid columns={3} gap={8} >
                    {getUserRoleInfo(null, 3, 1)}
                </Grid>
            </div>
        )
    } else if (lineupViewState.mode === LINEUP_VIEW_MODE.EDIT_LINEUP && lineupViewState.editableTeam === 1) {
        return (
            <div>
                {lineupTeamSelector}
                <div className="lineup-section-label">首发位置</div>

                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    color: '#1D2129'
                }}>
                    <div className="premium-pitch-container" style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '800px',
                        // 足球场背景统一从 icon.js 获取，方便后续整体替换
                        backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>
                        <div className="pitch-premium-divider"></div>

                        {/* Team A - Top */}
                        <div className="team-pitch-area">
                            <div className="pitch-info-bar pitch-info-bar-top">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                </div>
                            </div>
                            {getUserPositionInfo(1, false)}
                        </div>

                        {/* Team B - Bottom */}
                        <div className="team-pitch-area">
                            {getUserPositionInfo(2, true)}
                            <div className="pitch-info-bar pitch-info-bar-bottom">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="premium-btn-formation-wrapper">
                    <Button
                        className="premium-btn-formation"
                        block
                        color='none'
                        loading={joinButtonLoading}
                        onClick={() => {
                            setJoinButtonLoading(true)
                            const formData = new FormData();
                            formData.append('memberId', lineupOperatorId);
                            formData.append('pos', JSON.stringify(tempLocalPos));
                            formData.append('gameId', gameDetail.id)
                            axios.post(API_ROUTES.game_firstModel, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                                .then(function (response) {
                                    const result = response.data
                                    if (result.code === 200) {
                                        Toast.show({
                                            icon: 'success',
                                            content: "确认成功！"
                                        })
                                        localStorage.removeItem("memberTempPos")
                                        getGameDetail()
                                    } else {
                                        console.log(result)
                                        Toast.show({
                                            icon: 'fail',
                                            content: result.msg
                                        })
                                    }
                                })
                                .catch(function (error) {
                                    Toast.show({
                                        icon: 'fail',
                                        content: "系统错误！请联系管理员",
                                    })
                                })
                                .finally(() => {
                                    setJoinButtonLoading(false)
                                });
                        }}>
                        <span className="premium-btn-formation-icon">✓</span> 确认首发阵容
                    </Button>
                </div>
                <Divider>替补阵容</Divider>
                <Grid columns={10} gap={8}>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(1)}队长: {greenCaptain?.name}
                        </div>
                        {getUserSubstituteInfo(1, 'type2')}
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(2)}队长: {redCaptian?.name}
                        </div>
                        {getUserSubstituteInfo(2, 'type2')}
                    </Grid.Item>
                </Grid>
                {memberListInfo?.filter(item => item.gameType === 0 && item.gameTeam === null)?.length > 0 &&
                    <Card
                        className="premium-lineup-card"
                        title={
                            renderPendingTitle()
                        }
                    >
                        <Grid columns={3} gap={8} >
                            {getUserRoleInfo(null, 3, 1)}
                        </Grid>
                    </Card>
                }
            </div>
        )
    } else {
        return (
            <div>
                {lineupTeamSelector}
                <div className="lineup-section-label">首发位置</div>
                <div className="premium-btn-formation-wrapper" style={{ display: lineupViewState.editableTeam ? 'flex' : 'none' }}>
                    <Button
                        block
                        className="premium-btn-formation lineup-action-secondary"
                        color='none'
                        onClick={() => {
                            Dialog.confirm({
                                title: (
                                    <div className="premium-dialog-header">
                                        <span className="premium-dialog-title-icon">🔄</span>
                                        <span className="premium-dialog-title-text">重置首发阵容</span>
                                    </div>
                                ),
                                content: (
                                    <div className="premium-dialog-body" style={{ textAlign: 'center', color: '#4E5969' }}>
                                        点击确认将清除当前队伍的所有首发人员设置，是否确认？
                                    </div>
                                ),
                                onConfirm: () => {
                                    Toast.show({
                                        icon: 'loading',
                                        duration: 0
                                    })
                                    const formData = new FormData();
                                    formData.append('memberId', lineupOperatorId);
                                    formData.append('gameId', gameDetail.id)
                                    axios.post(API_ROUTES.game_reset_team_model, formData, {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    })
                                        .then(function (response) {
                                            const result = response.data
                                            if (result.code === 200) {
                                                Toast.show({
                                                    icon: 'success',
                                                    content: "重置成功！"
                                                })
                                                localStorage.removeItem("memberTempPos")
                                                window.location.reload()
                                            } else {
                                                console.log(result)
                                                Toast.show({
                                                    icon: 'fail',
                                                    content: result.msg
                                                })
                                            }
                                        })
                                        .catch(function (error) {
                                            console.log(error);
                                            Toast.show({
                                                icon: 'fail',
                                                content: "系统错误！请联系管理员",
                                            })
                                        })
                                        .finally(() => {
                                        });
                                },
                            })
                        }}
                    >
                        <span className="premium-btn-formation-icon">🔄</span> 重置首发阵容
                    </Button>
                </div>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    height: '800px',
                    color: '#1D2129'
                }}>
                    <div className="premium-pitch-container" style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '800px',
                        // 足球场背景统一从 icon.js 获取，方便后续整体替换
                        backgroundImage: `url(${Icon.FOOTBALL_FIELD_BACKGROUND})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}>
                        <div className="pitch-premium-divider"></div>

                        {/* Team A - Top */}
                        <div className="team-pitch-area">
                            <div className="pitch-info-bar pitch-info-bar-top">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.greenModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(1)}岁 | {avgGrade(1)}分</span>
                                </div>
                            </div>
                            {getUserPositionInfo(1, true)}
                        </div>

                        {/* Team B - Bottom */}
                        <div className="team-pitch-area">
                            {getUserPositionInfo(2, true)}
                            <div className="pitch-info-bar pitch-info-bar-bottom">
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">阵容: {getModelContent(gameDetail?.redModel)}</span>
                                </div>
                                <div className="pitch-tag-group">
                                    <span className="pitch-premium-tag">📊 {avgAge(2)}岁 | {avgGrade(2)}分</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Divider>替补阵容</Divider>
                <Grid columns={10} gap={8}>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(1)}队长: {greenCaptain?.name}
                        </div>
                        {getUserSubstituteInfo(1, 'type3')}
                    </Grid.Item>
                    <Grid.Item span={5}>
                        <div className="premium-compact-header" style={{ marginBottom: '8px', textAlign: 'center', color: '#475569', fontSize: '13px', fontWeight: '700' }}>
                            {getTeamName(2)}队长: {redCaptian?.name}
                        </div>
                        {getUserSubstituteInfo(2, 'type3')}
                    </Grid.Item>
                </Grid>
                {renderPendingTitle()}
                <Grid columns={3} gap={8} >
                    {getUserRoleInfo(null, 3, 1)}
                </Grid>
            </div>
        )
    }
}


export default GameFirstInfo;
